import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import PageHeading from "../pageHeading/PageHeading";
import "./managePayment.scss";
import { Button, Row, Col } from "react-bootstrap";
import { Calendar2WeekFill } from "react-bootstrap-icons";
import { setLoader } from "../../slice/commonSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchProviderJobInvoice,
  fetchProviderRevenueData,
  fetchTransactionDetails,
  fetchUserRevenueData,
} from "../../services/auth.service";
import { selectUser } from "../../slice/authSlice";
import Paginate from "../paginate/Paginate";
import ReactDatePicker from "react-datepicker";
import { base64toBlob } from "../../utils/common";
import { toast } from "react-toastify";
import { CiReceipt } from "react-icons/ci";

const TransactionHistory = () => {
  let user = useSelector(selectUser);
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [revenueData, setRevenueData] = useState();
  const [totalPages, setTotalPages] = useState(10);
  const [page, setPage] = useState(1);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  useEffect(() => {
    if (user) {
      fetchJob();
      fetchRevenueInfo();
    }
  }, [user]);
  const fetchJob = async (currentpage, startdate, enddate) => {
    let payload = {
      userId: user?.id,
      limit: 10,
      page: currentpage || 1,
      startDate: startdate ? startdate : startDate,
      endDate: enddate ? enddate : endDate,
      userType: user?.userType,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchTransactionDetails(payload);
      await dispatch(setLoader(false));
      setList(response.data?.transaction);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const fetchRevenueInfo = async () => {
    await dispatch(setLoader(true));
    try {
      if (user?.userType === "provider") {
        const response = await fetchProviderRevenueData();
        await dispatch(setLoader(false));
        setRevenueData(response?.data);
      } else {
        const response = await fetchUserRevenueData();
        await dispatch(setLoader(false));
        setRevenueData(response?.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
    fetchJob(page);
  };

  //function to generate jonb invoice pdf
  const handleReceipt = async (jobId) => {
    try {
      const payload = {
        jobId: jobId,
        userType: user?.userType,
      };
      await dispatch(setLoader(true));
      const response = await fetchProviderJobInvoice(payload);
      if (response?.data?.status) {
        const pdfData = response.data.data; // Base64 encoded PDF data
        const blob = base64toBlob(pdfData, "application/pdf");
        const link = document.createElement("a");
        const blobUrl = window.URL.createObjectURL(blob);
        link.href = blobUrl;

        var currentDate = new Date();
        var year = currentDate.getFullYear();
        var month = ("0" + (currentDate.getMonth() + 1)).slice(-2); // Adding 1 because months are zero-based
        var day = ("0" + currentDate.getDate()).slice(-2);

        // Create the file name with the current date
        var fileName = "jobsinvoice_" + year + "_" + month + "_" + day + ".pdf";

        // Set the download attribute of the link
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        await dispatch(setLoader(false));
      } else {
        toast.error(response?.data?.message);
        await dispatch(setLoader(false));
      }
    } catch (error) {
      console.log("error", error);
      await dispatch(setLoader(false));
    }
  };

  return (
    <>
      <Header />
      <PageHeading title="Transaction History" />
      <div className="main-container">
        <div className="my-wallet-wrapper">
          {user?.userType === "provider" ? (
            <>
              <div className="revenue-wrapper">
                <div className="revenue-box">
                  <div className="revenue-title">Total Revenue</div>
                  <div className="revenue-amount">$ {revenueData?.revenue}</div>
                </div>
                <div className="revenue-box">
                  <div className="revenue-title">Job Revenue</div>
                  <div className="revenue-amount">
                    $ {revenueData?.jobsRevenue}
                  </div>
                </div>
                <div className="revenue-box">
                  <div className="revenue-title">Tip Revenue</div>
                  <div className="revenue-amount">
                    $ {revenueData?.tipRevenue}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="revenue-wrapper">
              <div className="revenue-box">
                <div className="revenue-title">Total Spent</div>
                <div className="revenue-amount">
                  $ {revenueData?.totalSpent}
                </div>
              </div>
            </div>
          )}

          <div className="payment-history-wrap">
            <div className="payment-history-header">
              <div className="payment-history-title">Payment History</div>
              <div className="payment-history-date-wrap">
                <div className="icon-wrap">
                  <Calendar2WeekFill />{" "}
                </div>
                <div className="payment-history-date">
                  <Row>
                    <Col>
                      <div style={{ position: "relative" }}>
                        <ReactDatePicker
                          className="form-control"
                          selected={startDate}
                          onChange={(date) => {
                            setStartDate(date);
                            fetchJob("", date);
                          }}
                          placeholderText="Start Date"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div style={{ position: "relative" }}>
                        <ReactDatePicker
                          className="form-control"
                          selected={endDate}
                          onChange={(date) => {
                            setEndDate(date);
                            fetchJob("", "", date);
                          }}
                          placeholderText="End Date"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {list?.length > 0 ? (
              <>
                {list?.map((item, index) => (
                  <div key={index} className="transaction-history-wrap">
                    <div className="transaction-history">
                      <div className="transaction-details">
                        <div className="transaction-title">
                          {user?.userType === "user"
                            ? "Debited"
                            : item?.transactionType === "sub"
                            ? "Debited"
                            : "Received"}
                        </div>
                        <div className="transactionid">
                          Transaction Id: <span>{item?.transactionId}</span>
                        </div>
                        <div className="transaction-message">
                          {/* payment received from methon for Home moving Service */}
                          {item?.message}
                        </div>
                      </div>

                      <div
                        style={{
                          color: user?.userType === "user" ? "red" : "green",
                        }}
                      >
                        ${Number(item?.finalAmount.toFixed(2))}
                      </div>

                      <Button
                        variant="outline-primary"
                        onClick={() => handleReceipt(item?.jobId)}
                      >
                        <CiReceipt />
                        Receipt
                      </Button>
                    </div>
                  </div>
                ))}
                <Paginate
                  totalPages={totalPages}
                  currentPage={page}
                  onPageChange={handlePageChange}
                />
              </>
            ) : (
              <p>No transction found</p>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TransactionHistory;
